module.exports = __webpack_public_path__ + "static/circle-logo-981d40489d9a8abbdc5932efcd9d06b5.svg";